module.exports = __webpack_public_path__ + "9b442295c1aa55a5d191b8e2c8585d66.svg";